import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cc1e55ea")

_pushScopeId("data-v-cc1e55ea")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("h1", null, [
      _createVNode("div", null, _toDisplayString(_ctx.course.name), 1)
    ]),
    (_ctx.course.teams.length == 0)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock("p", _hoisted_2, "There are currently no teams for this course. "))
            : _createCommentVNode("", true),
          (!_ctx.canEdit)
            ? (_openBlock(), _createBlock("p", _hoisted_3, "You are not currently a member of any team for this course."))
            : _createCommentVNode("", true),
          (_ctx.canEdit)
            ? (_openBlock(), _createBlock("p", _hoisted_4, "Use the below button to create a team and channels for this course."))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.course.teams.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createTextVNode(" The following team" + _toDisplayString(_ctx.course.teams.length > 1 ? "s have" : " has") + " been created: ", 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.course.teams, (team) => {
            return (_openBlock(), _createBlock("div", {
              class: "team-block",
              key: team.id
            }, [
              (_ctx.canEdit)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    class: "edit-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('edit', team)), ["prevent"])
                  }, "Edit", 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode("a", {
                href: team.url,
                target: "_blank"
              }, _toDisplayString(team.name), 9, ["href"]),
              (team.contexts[0].type == _ctx.ContextType.Course)
                ? (_openBlock(), _createBlock("div", _hoisted_6, "Entire course"))
                : _createCommentVNode("", true),
              (team.contexts[0].type == _ctx.ContextType.Section)
                ? (_openBlock(), _createBlock("div", _hoisted_7, _toDisplayString(team.contexts.length) + " section" + _toDisplayString(team.contexts.length == 1 ? "": "s"), 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.canEdit)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newTeam && _ctx.newTeam(...args)))
          }, "New team"),
          _hoisted_9,
          (_ctx.course.teams.length > 0)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('sync')))
              }, "Update members"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})